<template>
  <TarjetaDatos titulo="Caracteristicas Local">
    <Campo2L :valor="poliza.regimenLocalNeg" etiqueta="Propiedad" />
    <Campo2L :valor="poliza.superficieNeg" etiqueta="Superficie" />
    <Campo2L :valor="poliza.anyoConstruccion" etiqueta="Año Construcción" />
    <Campo2L :valor="poliza.anyoReforma" etiqueta="Año Reforma" />    
  </TarjetaDatos>
</template>

<script>
export default {
  props: {
    poliza: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped></style>
